export default "__VITE_ASSET__53944d0a__"